/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';

export interface Framework {
  code: string;
  name: string;
  created?: string;
  description?: string;
  shortName?: string;
  type?: string;
  items?: {
    sdgCodes: string[];
    itemName: string;
    itemCode: string;
    displayCode: string;
  }[]
}

export interface SunburstDataItem {
  code: string;
  name: string;
  type?: string; // User for url slug
  value?: number;
  children?: SunburstDataItem[];
}

interface ReportingFrameworkStateData {
  frameworks: Framework[];
  map: SunburstDataItem
}

interface ReportingFrameworkState {
  reportType?: string,
  data?: ReportingFrameworkStateData,
  loaded: boolean,
  errored: boolean,
  errorMessage?: string,
  lastUpdated?: number
}

const reportingFrameworks = (

  state: ReportingFrameworkState = {
    reportType: '',
    data: undefined,
    loaded: false,
    errored: false,
    errorMessage: '',
  },

  action: {
    type: string,
    reportType?: string,
    errorMessage?: string,
    data?: ReportingFrameworkStateData
  }

) => {

  switch (action.type) {

    case actionTypes.LOADING_REPORTING_FRAMEWORKS:
      return { ...state, data: undefined, reportType: action.reportType, loaded: false, errored: false, lastUpdated: Date.now() }
    case actionTypes.ERROR_REPORTING_FRAMEWORKS:
      return { ...state, data: undefined, loaded: false, errored: true, lastUpdated: Date.now(), errorMessage: action.errorMessage }
    case actionTypes.LOADED_REPORTING_FRAMEWORKS:
      return { ...state, data: action.data, reportType: action.reportType, loaded: true, errored: false, lastUpdated: Date.now() }
    default:
      return state;

  }

}

export default reportingFrameworks;
